module.exports = __webpack_public_path__ + "img/logo_microsoft.b744d236.png";